/* eslint-disable camelcase */
import React from 'react'
import { Link } from 'react-router-dom'

// export const EventDetailCard = ({ type, evento = {} }) => {
export const EventDetailCard = (evento, { type, codigo_qr }) => {
  return (
    <div className="card border-card bg-black text-light mt-3">
        {/* <div className="img-wrapper zoom">
          <img src={evento.foto_portada} className="card-img-top" alt={evento.nombre} />
        </div> */}
        <div className="card-body card-event-body">
          <h5
            className="card-title text-light mb-0">
            {evento.nombre}
          </h5>
          <p
              className="d-flex
              align-items-center fw-bold text-decoration-none"
             >
              {evento.ubicacion}
          </p>
          <Link to={`/mi-cuenta/estadisticas/total/${evento.id}`} className="card-title d-flex
              align-items-left fw-bold text-decoration-none mt-1 mb-n1">Estadísticas</Link>
          <div className="card-event-data">
            <p className="d-flex align-items-center fw-bold text-decoration-none mt-1 mb-n2">{evento.fecha}</p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              Ingresos: {evento.precio} MXN
            </p>
            <div className='d-flex
               fw-bold text-decoration-none mt-1 mb-n2 justify-content:space-between'>
            {evento.funciones.map((funcion, index) => (
              <div key={index} className="me-2">
                <div>{`Showtime: ${funcion.fecha_funcion}`}</div>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
  )
}
